export default "__VITE_ASSET__QK$612Vx__"